// extracted by mini-css-extract-plugin
module.exports = {"Container":"Information_Container__3Bw_-","Header":"Information_Header__1KS-h","Currencies":"Information_Currencies__3AjPU"};